<template>
  <v-dialog width="660" :value="visible" @input="$emit('input', $event)" content-class="rounded-xl" style="z-index: 15">
    <v-sheet class="pa-6" min-height="400" style="position: relative">
      <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">프로모션 선택</p>
      <div style="position: absolute; right: 20px; top: 20px">
        <v-btn large depressed text @click="$emit('input', false)">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </div>
      <v-sheet class="mt-2 px-4">
        <v-row align="center" justify="start">
          <v-chip class="ma-1 py-8" v-for="promotion in promotions" :key="promotion.id" color="success" outlined @click.stop="addPromotion(promotion)">
            <div class="d-flex flex-column">
              <span class="text-center">{{ promotion.name || promotion.code }}</span>
            </div>
          </v-chip>
        </v-row>
      </v-sheet>
    </v-sheet>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  inject: ["promotions"],

  data: () => ({}),

  mounted() {},

  methods: {
    addPromotion(promotion) {
      this.$emit("add", promotion)
    },
  },
}
</script>
<style></style>
